import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { withTranslation } from 'react-i18next'; 

import React, { Component } from 'react'

import { getApiDatas } from "../utilities/FrontFunctions/AoxFrontFunctions"
import ObjTabsHomeFormation from './inc/ObjTabsHomeFormation'

import '../assets/css/0010_sections/0420_section_content_formation.css'
import '../assets/css/0010_sections/0450_section_home_carrousel_tabs_formation.css'

class PageBrand_TabsFormations extends Component {
    constructor(props) {
		super(props)
		this.state = {
		}
	}

    componentDidMount() {
        getApiDatas(`/apiaox/Call/PageBrand?sBrandCode=${this.props.fields.data.scDatas?.codeAbbrege.value}`).then((apiDatas) => { 
            this.setState({ apiDatas:apiDatas }) 
            window.scrollTo(0,0)
        })
    }

	render() {
        const { scDatas } = this.props.fields.data;
        const { apiDatas } = this.state;

        return (<>{scDatas && apiDatas && <>
			<section className="obj_section section_home_carrousel_tabs_formation">
                <div className="ctn_section">
                    <div className="ctn_title">
                        <h3 className="t_title"><strong>Mes formations</strong></h3>
                    </div>
                    
                    <div className="ctn_content">
                        <ObjTabsHomeFormation datasTrainings={apiDatas} datasPageFormations={scDatas.PageFormations[0]}/>
                    </div>
                </div>
            </section>
        </>}</>)
	}
}

export default withTranslation()(withSitecoreContext()(PageBrand_TabsFormations));